// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-account-register',
    validations: {
        registration: {
            eMail: {
                $rules: { required: true, type: 'email' }
            },
            password: {
                $rules: { required: true }
            },
            confirmPassword: {
                $rules: { required: true, equals: 'registration.password' }
            },
            firstName: {
                $rules: {
                    required: true
                },
            },
            lastName: {
                $rules: { required: true },
            },
            address_name1: {
                $rules: { required: true },
            },
            address_street: {
                $rules: { required: true },
            },
            address_zipcode: {
                $rules: { required: true },
            },
            address_city: {
                $rules: { required: true },
            },
            euvatid: {
                $rules: { required: true },
            }
        },
    },
    data: () => ({
        errorMessages: null,
        errorMessage: "",
        registration: {
            eMail: '',
            password: '',
            confirmPassword: '',
            firstName: '',
            lastName: '',
            telephone: '',
            euvatid: '',
            address_name1: '',
            address_name2: '',
            address_addition: '',
            address_street: '',
            address_zipcode: '',
            address_city: '',
            address_country: 'DE',
            accountMode: 'NEW'
        }
    }),
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableSubmit() {
            return false;
        }
    },
    methods: {
        hasErrors(data) {
            if (data.values === undefined) {
                return false;
            }
            return data.values.some((e) => !utils.isNullOrEmpty(e.message) && e.name.startsWith("$"));
        },
        filterErrors(data) {
            if (data.values === undefined) {
                return [];
            }
            let tdata = data.values.filter((e) => !utils.isNullOrEmpty(e.message) && e.name.startsWith("$"));
            return tdata;
        },
        OnExecute() {
            if (!this.validate()) {
                return;
            }
            appHost.api.post("/user", this.registration)
                // #region Succeeded
                .then((e) => {
                this.Login();
            })
                // #endregion
                // #region Error
                .catch((e) => {
                // #region Message
                let tError = '';
                if (e.response.data.errors) {
                    //Info
                    this.errorMessages = e.response.data.errors;
                    //Append
                    Object.keys(e.response.data.errors).forEach((k) => {
                        if (utils.isArray(e.response.data.errors[k])) {
                            let tCounter = 0;
                            e.response.data.errors[k].forEach((e) => {
                                this.$form.setError("$." + k + (tCounter === 0 ? '' : '.' + tCounter), e);
                                tCounter++;
                            });
                        }
                        else {
                            this.$form.setError("$." + k, e.response.data.errors[k]);
                        }
                    });
                }
                else if (e.response.data.error_description) {
                    tError = e.response.data.error_description;
                }
                else if (e.response.data.error) {
                    tError = e.response.data.error;
                }
                else {
                    tError = "Unbekannter Fehler bei der Anmeldung";
                }
                // #endregion
                if (tError) {
                    this.$form.setError("$", tError);
                }
            });
            // #endregion
        },
        Login() {
            appHost.login.loginByUsername(this.registration.eMail, this.registration.password).then((e) => {
                if (!e.isSucceded && e.errorCode === "account_activate") {
                    this.$router.push({ name: "login-activate", params: { userId: e.customData.userid } });
                }
                else if (!e.isSucceded) {
                    this.errorMessage = e.errorMessage;
                }
                else {
                    this.$router.push("/");
                }
            });
        }
    }
});
// #endregion
